import React from 'react';
import ReactDOM from 'react-dom';
import emailjs from 'emailjs-com';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import $ from 'jquery'; 
/* eslint-disable no-unused-expressions */
//disables unused expressions rule above.

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')

);
var opened_img = false;




document.getElementById("darkModesBox").addEventListener("click", function (event) {
    var isClickInsideElement = event.target.classList.contains("clickable");
    //true or falsevaiabledepeding on if clicked element has teclickabl class.
    if (!isClickInsideElement) {
        document.getElementById("image-display").style.visibility = "hidden";
        document.getElementById("darkModesBox").style.filter = "brightness(100%)";
        opened_img = false;
        //Do something click is outside specified element
    }
    
    //make the image preview display invisible.
     false
});

document.getElementById("image-display").addEventListener("click", function (event) {
    var isClickInsideElement = event.target.classList.contains("clickable");
    //true or falsevaiabledepeding on if clicked element has teclickabl class.
    if (!isClickInsideElement) {
        document.getElementById("image-display").style.visibility = "hidden";
        document.getElementById("darkModesBox").style.filter = "brightness(100%)";
        opened_img = false;
        //Do something click is outside specified element
    }
    
    //make the image preview display invisible.
     false
});


// var vid1 = document.getElementById("vid_1");


// vid1.addEventListener('click', function (event) {
//     //console.log("video playing is");
//     if (vid1.muted === false) {
//         vid1.muted = true;
//     }
// }, false);

//if unmuted, then the video will autopmatically be muted again (while playing).

document.addEventListener('keydown', function (event) {
    if (event.key === "Escape") {
        document.getElementById("image-display").style.visibility = "hidden";
        document.getElementById("darkModesBox").style.filter = "brightness(100%)";
        //make the image preview display invisible.
    }
});// escape key maps to keycode `27`
//alternatively, press esc to close the nav bar.

document.getElementById("darkModes").addEventListener("click", function (event) {
    ToggleDarkMode(), false
});
//click the darkmode button to toggle dark mde on and off.

/* Set the width of the side navigation to 250px and the left margin of the page content to 250px and add a black background color to body */




// var intervalID = window.setInterval(myCallback, 5000);
// let bottom = true;
// function myCallback() {
//     if (bottom) {
//         document.getElementById("mySidenav").style.backgroundPosition = "top";
//         bottom = false;
//     }
//     else {
//         document.getElementById("mySidenav").style.backgroundPosition = "bottom";
//         bottom = true;
//     }
    
// }
//switch position of background animation (gif) in navbar on interval change.
var elems = document.getElementsByTagName('input');
let darkmode = false;
function ToggleDarkMode() {
    if (darkmode === false) {
        document.getElementById("main").style.color = "white";
        for (var i = 0; i < elems.length; i++) {
            elems[i].style.color = "white";
        }
        document.getElementById("formBod").style.backgroundColor = "darkgrey";
        document.getElementById("formBod").style.color = "black";
        document.getElementById("form2").style.backgroundColor = "black";
        document.getElementById("form2").style.color = "black";
        document.getElementById("form2").style.height = "98%";
        document.getElementById("form2").style.width = "80%";
        document.getElementById("btnSub").style.color = "white";
        document.getElementById("Quasimain").style.backgroundColor = "black";
        document.getElementById("play. ").style.backgroundColor = "black";
        document.getElementById("darkModes").innerHTML = "Darkmode: ON";
        document.getElementById("darkModesBox").style.filter = "brightness(85%)";
        document.body.style.backgroundColor = "rgba(0,0,0,1)";
        document.getElementById("Footer").style.backgroundColor = "rgb(7, 7, 7)";
        document.documentElement.style.setProperty('--back-color', 'black');
        blackText();
        darkmode = true;
    }//If darkmode is off, turn it on.
    else if (darkmode === true) {
        for (var i = 0; i < elems.length; i++) {
            elems[i].style.color = "black";
        }
        document.getElementById("formBod").style.backgroundColor = "#627b8a";
        document.getElementById("formBod").style.color = "black";
        document.getElementById("form2").style.backgroundColor = "white";
        document.getElementById("form2").style.height = "89%";
        document.getElementById("btnSub").style.color = "black";
        document.getElementById("main").style.color = "black";
        // document.getElementById("Quasimain").style.backgroundColor = "lightgrey";
        document.getElementById("Quasimain").style.backgroundColor = "white";
        document.getElementById("play. ").style.backgroundColor = "lightsteelblue";
        document.getElementById("darkModes").innerHTML = "Darkmode: OFF";
        document.getElementById("darkModesBox").style.filter = "brightness(100%)";
        document.body.style.backgroundColor = "black";
        document.documentElement.style.setProperty('--back-color', 'white');
        darkmode = false;
    }//If darkmode is on, turn it off.
}
//toggle dark mode on and off.


function blackText() {
	var elements = document.getElementsByClassName('form-control'); // get all elements
	for(var i = 0; i < elements.length; i++){
		elements[i].style.color = "#111";
	}
}
//Above makes sure that the input text for the email inputs stay black instead of an illegible white.

let currImageIndex = 0;
let currPairIndex = 0;
//key value obj and array index data.

const imgArr = new Array(20);
let m = 1;
//m will represent the current number of the image. (img '1' a) and (img '1' b) will share the same number of '1' which is m's value.


//below is a key value pair containing both a berf description for each image, and the path to them.
const img_list_obj = {
    "in-extension create account page": "/images/in-extension images/extension create account page.png",
    "mock-up create account page": "/images/mock-up images/mock-up create account page.png",
    "in-extension login page": "/images/in-extension images/extension log in page.png",
    "mock-up login page": "/images/mock-up images/mock-up login page.png",
    "in-extension about page": "/images/in-extension images/extension about page.png",
    "mock-up welcome page": "/images/mock-up images/mock-up welcome page.png",
    "in-extension decode page": "/images/in-extension images/extension decode page.png",
    "mock-up Decode page": "/images/mock-up images/mock-up Decode page.png",
    "in-extension main menu page": "/images/in-extension images/extension main menu page.png",
    "mock-up main menu page": "/images/mock-up images/mock-up main menu page.png",
    "in-extension text settings page": "/images/in-extension images/extension text settings page.png",
    "mock-up text settings page": "/images/mock-up images/mock-up text settings page.png",
    "in-extension screen settings page": "/images/in-extension images/extension screen settings page.png",
    "mock-up screen settings page": "/images/mock-up images/mock-up screen settings page.png",
    "in-extension content settings page": "/images/in-extension images/extension content settings page.png",
    "mock-up content settings page": "/images/mock-up images/mock-up content settings page.png",
    "in-extension all set page": "/images/in-extension images/extension all set page.png",
    "mock-up all set page.png": "/images/mock-up images/mock-up all set page.png",
    "in-extension user settings page": "/images/in-extension images/extension user settings page.png",
    "mock-up user settings page": "/images/mock-up images/mock-up user settings page.png",
};


for (const [key, value] of Object.entries(img_list_obj)) {
    //console.log(`${key}: ${value}`);
}
//logs each key and value of the key value pair object we just innitialized.

for (var i = 0; i < imgArr.length; i++) {
    if (i % 2 === 0) {
        //alert('Even Number');
        imgArr[i] = "img" + (m).toString() + "b";
        //console.log(imgArr[i]);
        } else {
        //alert('Odd Number');
        imgArr[i] = "img" + (m).toString() + "a";
        //console.log(imgArr[i]);
        m++;
        //after a has been updated we can move on to the next number since the set is complete. (update m)
    }
    //if even number then assign it as i + "b"
    //else it is odd and assign it i + "a"
}
//create array and fill it with the correct naming conventions for each image. (img1a, img2b, and so on. .. )
//a is the first row, b is the second.

for (var i = 0; i < imgArr.length; i++) {
    //alert(imgArr[i]);
    var k = document.getElementById(imgArr[i]);
    (function () {
        var boxa = k.id;
        //var boxb = elem[k].parentNode.id;
        document.getElementById(imgArr[i]).addEventListener("click", function (event) {
        handleImageClicks(boxa), false
        });
    }()); // immediate invocation
    //had to pt into function because of issues accessing data within the for_loop. (stored element id)
    //pass current id for reference in the function.
}
//itterate through the array and add an event listener to each imae on click. 
//The events will all call the same function (below)

function handleImageClicks(imageId) {
    opened_img = true;
    //alert(imageId);
    document.getElementById("darkModesBox").style.filter = "brightness(20%)";
    //adjust the view of the background while image preview is visible.
    for (i = 0; i < imgArr.length; i++) {
        if (imageId === imgArr[i]) {
            //alert(imgArr[i]);
            currImageIndex = i;
            //alert(i);
        } 
    }
    //look for the current index based on the id of the image that hjad been clicked. 
    //Update the index with that value.
    currPairIndex = 0;
    //reset the pair index to 0

    for (const [key, value] of Object.entries(img_list_obj)) {
        if (currImageIndex === currPairIndex) {
            document.getElementById("curr_Img").src = value;
            document.getElementById("img_descrip").innerHTML = key;
            //just realised i could use the src on each image instead of storing them but i already did it so i will optomize later.
            //anyway we use the key as the description of the image and the value as the path to the image.
            break;
        }
        //console.log(`${key}: ${value}`);
        currPairIndex++;
    }
    //update current index after each itteration through the object's pairs 
    //and a check to see if it matches the current index in the array image of data.

    document.getElementById("image-display").style.visibility = "visible";
    //
    //make the image preview display visible for the user to see.
}

//component renders below
document.getElementById("contactForm").addEventListener('submit', sendEmail)

function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('service_e39nhbs', 'template_ahzwiud', e.target, 'user_ZtV5E7xUWpVGDORODo8ww')
        .then((result) => {
            console.log(result.text);
            document.getElementById("message_recaived").innerHTML = "Thank you for submitting your message! I will get back to you within a day or two; be it business or otherwise.";
        }, (error) => {
            console.log(error.text);
            document.getElementById("message_recaived").innerHTML = "I'm sorry, something went wrong, it is possible that my inbox is full for the time being - please try again later. You may also try another form of contact below. THank you very much for your interest in me!";
        });
    e.target.reset();
    console.log("HELLO! I sent email!");    
    //above resets the form instead of getting rid of it.
};

    //based on the name of each field that is how the API will know which field's input to use for each portion of the email.


function expandContract() {
    const el = document.getElementById("expand-contract")
    el.classList.toggle('expanded')
    el.classList.toggle('collapsed')
}


document.getElementById("expandContractBtn").addEventListener('click', expandContract);


$(document).ready(function () {
    if ($(window).width() > 991) {
      $(".navbar-light .d-menu").hover(
        function () {
          $(this).find(".sm-menu").first().stop(true, true).slideDown(150);
        },
        function () {
          $(this)
            .find(".sm-menu")
            .first()
            .stop(true, true)
            .delay(120)
            .slideUp(100);
        }
      );
    }
  });


function helperEnabled(event){
    var elementTarget = document.getElementById("root");
    if (window.scrollY > (elementTarget.offsetTop + elementTarget.offsetHeight)) {
        //alert("You've scrolled past the second div");
        document.getElementById("miniMeAssistance").style.display = "block";
       console.log("Helper Assistanct 'MiniMe' enabled.");
       window.removeEventListener("scroll", helperEnabled, true);
    }
	
}

window.addEventListener("scroll", helperEnabled, true);

var el = document.getElementById("HovrCaption");

document.getElementById("buttonsContac").addEventListener("mouseover", function( event ) {
    // var x = event.pageX;
    // var y = event.pageY;
    
    
    var x = event.clientX;
    var y = event.clientY;
    var el1 = document.elementFromPoint(x, y); 
    el.style.display = "block";
    // el.style.position', 'absolute');
    el.style.left = x.toString() + "px";
    //el.style.top = y.toString() + "px";
    if (el1.className == "btn btn-outline-light btn-floating m-1" || el1.classList.contains("fab")){
        el.innerHTML = el1.id;
    }
    //use id on hover to inform user of the name of the icon/site linked.
    //alert("mouse over test!");
    
    else {
        el.style.display = "none";
    }
    //console.log("HELLO!!");
}, false);

document.getElementById("buttonsContac").addEventListener("mouseleave", function( event ) {
    // var x = event.pageX;
    // var y = event.pageY;
    document.getElementById("HovrCaption").style.display = "none";

}, false);
/*const projectList =
    React.createElement('div', {},
        React.createElement('div', { style: "display: flex;" },
            [
            React.createElement('div', { style: "padding-right: 0; right: 0; margin-right: 0; clear: right;"},
                [
                    React.createElement('a', { href: '#abt' }, '🤔'),
                    React.createElement('a', { href: '#Proj' }, '💡'),
                    React.createElement('a', { href: '#3jzs' }, '💡'),
                    React.createElement('a', { href: '#play' }, '🎮'),
                    React.createElement('a', { href: '#Contac' }, '✍️')
                ]
            ),
            React.createElement('div', {},
                [
                    React.createElement('a', { href: '#abt' }, 'About Me'),
                    React.createElement('a', { href: '#Proj' }, 'My Projects'),
                    React.createElement('a', { href: '#3jzs' }, '3.js Project'),
                    React.createElement('a', { href: '#play' }, 'Play a Game'),
                    React.createElement('a', { href: '#Contac' }, 'Contact Me')
                ]
            )
            ]
        )
    );

ReactDOM.render(
    projectList,
    document.getElementById('nav_stuff')
);*/
//Above we create some elements and fill the page with them.

/*alert("hi");*/
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
